import React from 'react';
import { useParams } from 'react-router-dom';

import RatingStar from './RatingStar';

export default function Rating(props) {
  const { id } = useParams();
  const { rating, reviews, setTabType } = props;

  return (
    <>
      <div id={`rating${id}`} className="d-flex mb-4">
        <RatingStar stars={rating} />
        {rating.toFixed(1)}
        {' '}
        分 |
        <a
          href="#comment"
          onClick={() => {
            setTabType('comment');
          }}
        >
          {reviews}
          {' '}
          個評價
        </a>
      </div>
    </>
  );
}
